import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationManagedUserGroupDeleteArgs,
  ManagedUserGroup,
  QueryManagedUserGroupArgs,
  Role,
} from "types/generated";

import { IdpGroupView } from "./types";

export type GetUserData = {
  managedUserGroup: IdpGroupView;
  roles: Pick<Role, "id" | "name" | "isSystem" | "description">[];
};

export const GET_USER_GROUP_WITH_ROLES: TypedDocumentNode<GetUserData, QueryManagedUserGroupArgs> =
  gql`
    query UserGroupRoleBinding($id: ID!) {
      managedUserGroup(id: $id) {
        id
        groupName
        identityProvider
        status
        spaceCount
        description
        managedUsers {
          id
          username
          lastLoginTime
          loginMethod
          status
        }
        lastLoginTime
        userRoleBindings {
          id
          roleID
          space {
            id
            name
          }
        }
      }
      roles {
        id
        name
        isSystem
        description
      }
    }
  `;

type DeleteManagedUserGroupData = {
  managedUserGroupDelete: Pick<ManagedUserGroup, "id">;
};

export const DELETE_MANAGED_USER_GROUP: TypedDocumentNode<
  DeleteManagedUserGroupData,
  MutationManagedUserGroupDeleteArgs
> = gql`
  mutation DeleteManagedUserGroup($id: ID!) {
    managedUserGroupDelete(id: $id) {
      id
    }
  }
`;
